<div class="modal fade" bsModal #recordsModal="bs-modal" [config]="{backdrop: 'static'}"
     tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-sm">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title pull-xs-left">{{title}}</h4>
                <button type="button" class="close float-sm-right" aria-label="Close" (click)="closeModal()">
                    <span aria-hidden="true"><img src="assets/img/icon-close-reversed.png"></span>
                </button>
            </div>
            <div class="modal-body">
                <div [ngSwitch]="selectedPage">
                        <div *ngSwitchCase="MyWizardPage.Options">
                            <div class="row" style="margin-left:0px">
                                <div> 
                                    Date Range
                                </div>
                                <div>
                                    <my-date-range-selector [defaultStartDate]="startDate"
                                                            [defaultEndDate]="endDate"
                                                            [maxDate]="endDate"
                                                            [skipDataStore]="true"
                                                            (selectedChange)="onDateRangeSelection($event)"
                                                            (dateRangeValidated)="onDateRangeValidated($event)">
                                    </my-date-range-selector>
                                </div>
                            </div> 
                            <div class="row" style="margin:0px" >
                                <span class="modal-sub-header">Patient Status:</span>
                                
                                <div *ngFor="let patientStatus of patientStatuses">
                                    <label class="radio">
                                        <input type="radio" 
                                                name="patientStatus"
                                                [ngModel]="selectedPatientStatus"
                                                (ngModelChange)="selectedPatientStatusChange($event)"
                                                [value]="patientStatus"><span></span>
                                        {{patientStatus}}
                                    </label>
                                </div>
                            </div>
                            <div class="row" style="margin:0px">
                                <span class="modal-sub-header">
                                    Select DEA Class: 
                                </span>
                                <div *ngFor="let deaClass of deaClasses">
                                    <label [class]="areAllDeaClassesSelected ? 'checkbox-square' : 'checkbox'">
                                        <input type="checkbox" 
                                            (change)="selectDeaClass()" 
                                            [(ngModel)]="deaClass.IsSelected">
                                        <span></span>
                                        <span class="checkbox-label">
                                            {{deaClass.Name}}
                                        </span>
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div *ngSwitchCase="MyWizardPage.NursingStations">
                            <my-nursing-station-page [(nursingStations)]="allNursingStations">                                
                            </my-nursing-station-page>
                        </div>
                </div>
            </div>
            <div class="modal-footer">
                <div class="float-left text-align-left">
                    <div>
                        <div class="float-left text-align-left" *ngIf="selectedPage == MyWizardPage.Options">
                            <button class="btn btn-primary" (click)="closeModal()">Cancel</button>
                        </div>
                        <div class="float-left text-align-left" *ngIf="selectedPage != MyWizardPage.Options">
                            <button class="btn btn-primary" (click)="back()">Back</button>
                        </div>
                    </div>                    
                </div>
                <div class="float-right text-align-right">
                    <div [ngSwitch]="selectedPage">
                        <div *ngSwitchCase="MyWizardPage.Options">
                            <button (click)="showNursingStationsPage()"
                                    [disabled]="!canShowNursingStationsPage()"
                                    class="btn btn-primary">
                                <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">
                                Next: Select Nursing Stations
                            </button>
                        </div>
                        <div *ngSwitchCase="MyWizardPage.NursingStations">
                            <button (click)="generateContent()"
                                    [disabled]="!canGenerateReport()"
                                    class="btn btn-primary">
                                <img src="assets/img/loading.gif" height="25" width="25" [hidden]="hideSpinner">
                                Finished: Download Report
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>